<template>
    <section>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <!--open list-->
            <el-tab-pane label="To Confirm" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model="filters.viewedInboundFilter" placeholder="Offer or UPC" clearable @keyup.enter.native="getInboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getInboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportInboundViewing','Viewing.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="viewedInbound" highlight-current-row v-loading="firstLoading" style="width: 100%;">
                    <el-table-column label="#" prop="inboundNo">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer">
                    </el-table-column>
                    <el-table-column prop="userName" label="User">
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="num" label="Take">
                    </el-table-column>
                    <el-table-column prop="leftNum" label="Not Claimed">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="Take Offer Date">
                    </el-table-column>
                    <el-table-column label="Action" width="180px">
                        <template slot-scope="scope">
                            <el-button size="small" type="danger" @click="cancelInbound(scope.row.inboundNo)">Cancel</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeViewList" :page-size="pageSize"
                                   :total="viewInboundTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            <!--Groups list-->
            <el-tab-pane label="Reported/Missed" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model="filters.reportFilter" placeholder="Offer or UPC" clearable @keyup.enter.native="getReportList">
                                <el-button slot="append" icon="el-icon-search" @click="getReportList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="filters.reportStatus" clearable @change="getReportList">
                                <el-option label="Pending" :value="0"></el-option>
                                <el-option label="Rejected" :value="2"></el-option>
                                <el-option label="Confirmed" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportInboundViewingReported','reported.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="reportedInbound" highlight-current-row v-loading="secondLoading" style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="product" label="Offer">
                        <template slot-scope="scope">
                            <p>{{scope.row.productName}} {{scope.row.offerCreateDate?"("+scope.row.offerCreateDate+")":""}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user" label="User">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty">
                    </el-table-column>
                    <el-table-column label="Status">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status===0"><el-tag type="info">Pending</el-tag></p>
                            <p v-if="scope.row.status===1"><el-tag type="success">Confirmed</el-tag></p>
                            <p v-if="scope.row.status===2"><el-tag type="danger">Rejected</el-tag></p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="Report Date">
                    </el-table-column>
                    <el-table-column prop="note" label="Note">
                    </el-table-column>
                    <el-table-column label="Action" width="200">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status===0">
                                <el-button size="small" :loading="scope.row.loading||globalLoading" @click="editReportStatus(scope.row.id,1,scope.row)">Confirm</el-button>
                                <el-button size="small" :loading="scope.row.loading||globalLoading" type="danger" @click="editReportStatus(scope.row.id,2,scope.row)">Reject</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeReportPage" :page-size="pageSize" :total="reportTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Inbound History" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model="filters.historyFilter" placeholder="Offer or UPC" clearable @keyup.enter.native="getInboundHistoryList">
                                <el-button slot="append" icon="el-icon-search" @click="getInboundHistoryList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportInboundHistory','inboundHistory.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="inboundHistory" highlight-current-row v-loading="thirdLoading" @selection-change=""
                          style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer">
                    </el-table-column>
                    <el-table-column prop="tracking" label="Tracking">
                    </el-table-column>
                    <el-table-column prop="userName" label="User">
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="offerCreateDate" label="Offer Creation Date" >
                    </el-table-column>
                    <el-table-column prop="inboundDate" label="Inbound Date">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeHistoryList" :page-size="pageSize" :total="historyTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Nurse Cancelled" name="fourth">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model="filters.cancelFilter" placeholder="Offer or UPC" clearable @keyup.enter.native="getCancelInboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getCancelInboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportInboundNurseCancel','cancel.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="cancelList" highlight-current-row v-loading="fourthLoading" style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer">
                    </el-table-column>
                    <el-table-column prop="nurseName" label="User">
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="Cancel Date">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeCancelList" :page-size="pageSize" :total="cancelTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Tracking" name="five">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model="filters.trackingNumFilter" placeholder="Tracking Number or UPC, Product Name, Offer Id " clearable @keyup.enter.native="getTrackingList">
                                <el-button slot="append" icon="el-icon-search" @click="getTrackingList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker @change="getTrackingList"
                                    v-model="filters.trackingDate"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    range-separator="to"
                                    start-placeholder="startDate"
                                    end-placeholder="endDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportInboundTracking','tracking.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="trackingList" highlight-current-row v-loading="fiveLoading" @selection-change=""
                          style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="trackingNumber" label="Tracking Number">
                    </el-table-column>
                    <el-table-column prop="upc" label="UPC">
                    </el-table-column>
                    <el-table-column prop="productName" label="Product Name">
                    </el-table-column>
                    <el-table-column label="Offer ID">
                        <template slot-scope="scope">
                            <p v-if="scope.row.offerNo==0"></p>
                            <p v-else>{{scope.row.offerNo}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userName" label="User">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty">
                    </el-table-column>
                    <el-table-column prop="dateTime" label="DateTime">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeTracking" :page-size="pageSize" :total="trackingTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <!--编辑界面-->
        <el-dialog title="Offer Take Detail" width="80%" :visible.sync="detailVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true">
                    <el-form-item>
                        <el-input v-model="filters.name" placeholder="Offer">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-table stripe :data="inboundDetail" highlight-current-row v-loading="detailLoading" @selection-change=""
                      style="width: 100%;">
                <el-table-column label="#" prop="inboundNo">
                </el-table-column>
                <el-table-column prop="productName" label="Offer">
                </el-table-column>
                <el-table-column prop="userName" label="User">
                </el-table-column>
                <el-table-column prop="price" label="Price">
                </el-table-column>
                <el-table-column prop="num" label="Qty">
                </el-table-column>
                <el-table-column label="Warehouse" >
                    <template slot-scope="scope">
                        <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="Take Offer Date">
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="" :page-size="20" :total="total"
                               style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="detailVisible = false">Close</el-button>
            </div>
        </el-dialog>
    </section>
</template>


<script>
    import util from '../../common/js/util'
    import {
        getInboundList,
        getInboundHistoryList,
        getInboundDetailList,
        getDoctorTrackingList,
        getCancelInboundList,
        getNurseConfirmList,
        cancelInboundByDoctor
    } from "../../api/inboundService";
    import {getDoctorOffer} from "../../api/offerService";
    import {getInventoryReportList,editReportStatus} from "../../api/inventoryService";
    import {defaultPageSize} from "../../globalVar";
    import {exportExcel} from "../../api/exportService";
    import ElOption from "element-ui/packages/select/src/option";

    export default {
        components: {ElOption},
        data() {
            return {
                pageSize: defaultPageSize,

                currentDetailNo:"",
                inboundDetailPage:1,
                inboundDetailTotal:0,

                viewInboundPage: 1,
                viewInboundTotal: 0,

                historyPage:1,
                historyTotal:0,

                cancelPage:1,
                cancelTotal:0,

                reportPage:1,
                reportTotal:0,

                trackingPage:1,
                trackingTotal:0,

                activeName: "first",
                filters: {
                    name: '',
                    reportFilter:"",
                    cancelFilter:"",
                    viewedInboundFilter: "",
                    historyFilter:"",
                    trackingNumFilter:"",
                    trackingWarehouse:"",
                    trackingDate:"",
                },

                detailLoading:false,
                firstLoading: false,
                secondLoading: false,
                thirdLoading: false,
                fourthLoading: false,
                fiveLoading:false,

                cancelList:[],
                viewedInbound: [],
                reportedInbound: [],
                inboundHistory: [],
                inboundDetail: [],
                trackingList: [],
                total: 0,
                page: 1,
                listLoading: false,
                detailVisible: false,//编辑界面是否显示
                globalLoading:false

            }
        },
        methods: {
            cancelInbound(inboundNo){
                if(!inboundNo){
                    this.$message.error("Empty InboundNo");
                    return;
                }
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    cancelInboundByDoctor({inboundNo:inboundNo}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getInboundList();
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {

                });
            },
            exportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName
                }
                exportExcel(param).then(function(){

                })
            },
            editReportStatus(id,status,row){
                this.$confirm("Are you sure?","Warning",{
                    type:"warning"
                }).then(()=>{
                    row.loading = true;
                    let param = {
                        id:id,
                        status:status
                    }
                    this.globalLoading = true;
                    editReportStatus(param).then((data)=>{
                        row.loading = false;
                        this.globalLoading = false;
                        if(data.status===200){
                            this.$message.success(data.message);
                            this.getReportList();
                        }else{
                            this.$message.error(data.message);
                        }
                    })
                }).catch(()=>{
                    this.globalLoading = false;
                })
            },
            changeHistoryList(val){
                this.historyPage = val;
                this.getInboundHistoryList();
            },
            changeViewList(val){
                this.viewInboundPage = val;
                this.getInboundList();
            },
            changeReportPage(val){
                this.reportPage = val;
                this.getReportList();
            },
            changeCancelList(val){
                this.cancelPage = val;
                this.getCancelInboundList();
            },
            handleClick(tab, event) {
                if (tab.paneName === "first" && this.viewedInbound.length === 0) {
                    this.getInboundList();
                } else if (tab.paneName === "second" && this.reportedInbound.length === 0) {
                    this.getReportList();
                } else if (tab.paneName === "third" && this.inboundHistory.length === 0) {
                    this.getInboundHistoryList();
                } else if (tab.paneName === "fourth" && this.cancelList.length === 0) {
                    this.getCancelInboundList();
                }
            },
            getInboundList() {
                let param = {
                    current: this.viewInboundPage,
                    size: this.pageSize,
                    condition:this.filters.viewedInboundFilter
                };
                this.firstLoading = true;
                getInboundDetailList(param).then((data) => {
                    this.firstLoading = false;
                    if(data.status===200) {
                        this.viewedInbound = data.result.records;
                        this.viewInboundTotal = data.result.total;
                    }
                })
            },
            getReportList() {
                let param = {
                    current:this.reportPage,
                    size:this.pageSize,
                    condition:this.filters.reportFilter,
                    status:this.filters.reportStatus
                }
                this.secondLoading = true;
                this.reportedInbound = [];
                getInventoryReportList(param).then((data) => {
                    this.secondLoading = false;
                    if(data.status===200){
                        data.result.records.forEach((item)=>{
                            item.loading = false;
                            this.reportedInbound.push(item);
                        })
                        this.reportTotal = data.result.total;
                    }
                })
            },
            getInboundHistoryList() {
                let param = {
                    current:this.historyPage,
                    size:this.pageSize,
                    productName:this.filters.historyFilter
                };
                this.thirdLoading=  true;
                getInboundHistoryList(param).then((data) => {
                    this.thirdLoading=  false;
                    if(data.status===200){
                        this.inboundHistory = data.result.records;
                        this.historyTotal = data.result.total;
                    }
                })
            },
            getCancelInboundList() {
                let param = {
                    current:this.cancelPage,
                    size:this.pageSize,
                    productName:this.filters.cancelFilter
                };
                this.fourthLoading=  true;
                getCancelInboundList(param).then((data) => {
                    this.fourthLoading=  false;
                    if(data.status===200){
                        this.cancelList = data.result.records;
                        this.cancelTotal = data.result.total;
                    }
                })
            },
            getInboundDetailList(id) {
                if(id){
                    this.currentDetailNo = id;
                }
                let param = {
                    offerNo:this.currentDetailNo,
                    current:this.inboundDetailPage,
                    size:this.pageSize,
                    productName:""
                }
                this.detailLoading = true;
                getInboundDetailList(param).then((data) => {
                    this.detailLoading = false;
                    if(data.status===200){
                        this.inboundDetail = data.result.records;
                        this.inboundDetailTotal = data.result.total
                        this.detailVisible = true;
                    }
                })
            },
            changeTracking(val){
                this.trackingPage = val;
                this.getTrackingList();
            },
            getTrackingList() {
                let param = {
                    current:this.trackingPage,
                    size:this.pageSize,
                    warehouseNo:this.filters.trackingWarehouse,
                    startDate:"",
                    endDate:"",
                    tracking:this.filters.trackingNumFilter
                };
                if(this.filters.trackingDate){
                    param.startDate = this.filters.trackingDate[0];
                    param.endDate = this.filters.trackingDate[2];
                }
                this.fiveLoading = true;
                getDoctorTrackingList(param).then((data) => {
                    this.fiveLoading = false;
                    if(data.status===200){
                        this.trackingList = data.result.records;
                        this.trackingTotal = data.result.total;
                    }
                })
            }
        },
        mounted() {
            this.getInboundList();
            this.getTrackingList();
            this.getReportList();
            this.getInboundHistoryList();
            this.getCancelInboundList();
            let active = this.$route.params.active;
            if(active){
                this.activeName = active;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// inbound.vue?bd9b0134